module.exports = __webpack_public_path__ + "media/4x3/sj-ae547dbe.svg";